import { render } from "./LayoutMinimal.vue?vue&type=template&id=470d3085&scoped=true"
import script from "./LayoutMinimal.vue?vue&type=script&lang=js"
export * from "./LayoutMinimal.vue?vue&type=script&lang=js"

import "./LayoutMinimal.vue?vue&type=style&index=0&id=470d3085&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470d3085"]])

export default __exports__